<footer id="rs-footer" class="rs-footer home9-style">
  <div class="footer-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-12 footer-widget md-mb-40">
          <h3 class="widget-title footer-title">ABOUT US</h3>
          <div class="textwidget white-color footer-about">
            <p>
              <strong>Sri Sai Degree College,</strong><br>
               Gooty, with the Affiliated to Sri Krishnadevaraya University Anantapur
            </p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 footer-widget md-mb-40">
          <h3 class="widget-title footer-title">USEFUL LINKS</h3>
          <ul class="site-map footer-links">
            <li><a href="https://skuniversity.ac.in/" target="_blank" rel="noopener noreferrer">SK University Website</a></li>
            <li><a href="https://www.aicte-india.org/" target="_blank" rel="noopener noreferrer">AICTE</a></li>
            <li><a href="https://www.aicte-india.org/feedback/" target="_blank" rel="noopener noreferrer">AICTE Feedback</a></li>
            <li><a href="https://www.ugc.gov.in/" target="_blank" rel="noopener noreferrer">UGC</a></li>
            <li><a href="https://swayam.gov.in/" target="_blank" rel="noopener noreferrer">Swayam Portal</a></li>
            <li><a href="https://nptel.ac.in/" target="_blank" rel="noopener noreferrer">NPTEL Courses</a></li>
            <li><a href="https://www.ap.gov.in/?page_id=347" target="_blank" rel="noopener noreferrer">About Anantapuramu</a></li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 footer-widget md-mb-40">
          <h3 class="widget-title footer-title">QUICK LINKS</h3>
          <ul class="site-map footer-links">
            <li><a [routerLink]="['/gallery']">Gallery</a></li>
            <li><a [routerLink]="['/directory']">Alumni Portal</a></li>
            <li><a [routerLink]="['/grievance-portal']">Grievance Portal</a></li>
            <li><a [routerLink]="['/contact']">Contact Us</a></li>
            <li><a [routerLink]="['/mandatory-disclosure']">Important Documents</a></li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-12 col-sm-12 footer-widget md-mb-50">
          <h3 class="widget-title footer-title">CONTACT US</h3>
          <ul class="address-widget">
            <li>
              <i class="flaticon-location"></i>
              <div class="desc">
                <strong>Sri Sai Degree College</strong><br>                
                Near MarketYard, RS Road,Gooty,
                Anantapur-515401
                AndhraPradesh, India
              </div>
            </li>
            <li>
              <i class="flaticon-email"></i>
              <div class="desc">
                <a href="mailto:ssdcgty@gmail.com">	ssdcgty@gmail.com</a><br>
               
              </div>
            </li>
            <li>
              <i class="flaticon-call"></i>
              <div class="desc">
                <a href="tel:+91 9014219371">91 9014219371</a> 
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="container">
      <div class="row y-middle">
        <div class="col-lg-3 md-mb-20">
          <div class="footer-about-logo md-text-center">
            <a href="/"><img src="assets/college/srisaidegreecollege.png" alt="sri sai degree college.png"></a>
          </div>
        </div>
        <div class="col-lg-6 md-mb-20">
          <div class="copyright text-center">
            <p>&copy; 2026 Sri Balaji Educational Society. All Rights Reserved.</p>
          </div>
        </div>
        <div class="col-lg-3 text-right md-text-left">
          <ul class="footer-social">
            <li><a href="#"><i class="fa fa-facebook"></i></a></li>
            <li><a href="#"><i class="fa fa-twitter"></i></a></li>
            <li><a href="#"><i class="fa fa-instagram"></i></a></li>
            <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
            <li><a href="#"><i class="fa fa-pinterest-p"></i></a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
